import request from 'root/utils/request';

export default {
  namespace: 'property',
  state: {
    response: null
  },
  effects: {
    *asyncConfig({ url, options, isHiddenNote }, { call, put }) {
      const response = yield call(request(url, options, isHiddenNote));
      yield put({
        type: 'done',
        payload: response
      });
    }
  },
  reducers: {
    done(state, { payload }) {
      return {
        response: payload
      };
    }
  }
};
